'use client'

import { Footer } from './Footer'
import { useMainLayoutContent } from '../../providers/mainLayoutContent'

export const FooterConnector = () => {
  const { footer } = useMainLayoutContent()

  if (!footer) {
    return null
  }

  return <Footer {...footer} />
}
